module.exports = __webpack_public_path__ + "img/apple-appstore-badge.3d8f8251.png";